import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const TableIcon = withSvgIcon(
    <g>
        <path d="M112.7,170.34H15.21C4.52,170.33,0,165.89,0,155.16q0-70,0-140C0,4.42,4.48,0,15.2,0h195c10,0,14.69,4.61,14.69,14.67q0,70.48,0,141c0,10.08-4.65,14.67-14.67,14.67Q161.44,170.36,112.7,170.34ZM10.43,39.37H214.75c0-9.12,0-17.59,0-26.07a8.44,8.44,0,0,0-.86-2.44H10.43ZM147,50.65H78v29h69Zm0,40H78v29H147ZM77.88,159.69h69.05v-29H77.88ZM10.52,50.61v29H67v-29ZM214.46,79.72v-29H158v29ZM10.37,119.59H66.84V90.67H10.37Zm204,.15v-29H157.92v29Zm-147.51,40v-29H10.71v29Zm91-.23h56.59V130.72H157.86Z" />
    </g>,
    "0 0 224.89 170.34"
);
